import { PagedResult } from '../DTOs/Common/PagedResult'
import { StoppageCalc } from '../DTOs/Stoppage/StoppageCalc'
import { queryClient } from '../queryClient'

// Note: in a shift created offline the operations are provisional, so anything scoped to one carries
// a negative temp id that means nothing to the server. Record the plant it belongs to and the sync
// resolves the real operation for that shift once the completion procedure has created it.
export function provisionalPlantId(operationId: number | undefined): number | undefined {
  if (operationId === undefined || operationId >= 0) return undefined

  for (const [, page] of queryClient.getQueriesData<PagedResult<StoppageCalc>>({
    queryKey: ['dataTable', 'operations', 'stoppageCalcs'],
  })) {
    const match = (page?.data ?? []).find(row => row?.operationId === operationId)
    if (match?.plantId) return match.plantId
  }
  return undefined
}
